const reportData = [
    {
        title: "Annual Report",
        class: "annual-report",
        summary: "Here is the summary of the activities that gyws carried in the year",
        button: [
            {
                interval: "2022-23",
                link: "/assets/pdf/Annual_Reports/2022-23 Annual Report Final.pdf"
            },
            {
                interval: "2021-22",
                link: "/assets/pdf/Annual_Reports/Annual_Report_21-22.pdf"
            },
            {
                interval: "2020-21",
                link: "/assets/pdf/Annual_Reports/Annual_Report_20-21.pdf"
            },
            {
                interval: "2019-20",
                link: "/assets/pdf/Annual_Reports/Annual_Report_19-20.pdf"
            },
            {
                interval: "2018-19",
                link: "/assets/pdf/Annual_Reports/Annual_Report_18-19.pdf"
            },
            {
                interval: "2017-18",
                link: "/assets/pdf/Annual_Reports/Annual_Report_17-18.pdf"
            },
            {
                interval: "2016-17",
                link: "/assets/pdf/Annual_Reports/Annual_Report_16-17.pdf"
            }
        ]
    },
    {
        title: "Impact Report",
        class: "impact-report",
        summary: "It represents our final performance update on our annual targets and their impact",
        button: [
            {
                interval: "2025-26",
                link: "/assets/pdf//Impact_report/Impact report 2025-26.pdf"
            },
            {
                interval: "2022-23",
                link: "/assets/pdf//Impact_report/Impact Report 2022-2023 (1).pdf"
            },
            {
                interval: "2021-22",
                link: "/assets/pdf/Impact_report/Impact Report 2021-22.pdf"
            },
            {
                interval: "2020-21",
                link: "/assets/pdf/Impact_report/Impact Report 2020-21.pdf"
            },
            {
                interval: "2019-20",
                link: "/assets/pdf/Impact_report/Impact Report 19-20.pdf"
            },
            {
                interval: "2018-19",
                link: "/assets/pdf/Impact_report/Impact Report 2018-19.pdf"
            },
            {
                interval: "2017-18",
                link: "/assets/pdf/Impact_report/Impact_Report_2017-18.pdf"
            },
            {
                interval: "2016-17",
                link: "/assets/pdf/Impact_report/Impact_Report_2016-17.pdf"
            }
        ]
    },
    {
        title: "Quaterly Finance Reports",
        class: "quaterly-finance-report",
        summary: "Statement of expenses and donations received for Quarterly Finance Reports",
        button: [
            {
                interval: "JAN-MAR 2023",
                link: "/assets/pdf/Quaterly_reports/JANUARY - MARCH 2023 Quarterly Report.pdf"
            },
            {
                interval: "APR-JUN 2023",
                link: "/assets/pdf/Quaterly_reports/APRIL - JUNE 2023 Quarterly Report.pdf"
            },
            {
                interval: "JUL-SEP 2023",
                link: "/assets/pdf/Quaterly_reports/JULY-SEPT 2023 Quarterly Report.pdf"
            },
            {
                interval: "OCT-DEC 2023",
                link: "/assets/pdf/Quaterly_reports/OCT-DEC 2023 Quarterly Report.pdf"
            },
        ]
    }
];


export default reportData;